<!--
 * @createTime: 2022-7-8 14:11:45
 * @creater: 钱磊
 * @Description: 各类业务查看页面
-->
<template>
	<div class="service-provider-layout">
		<div class="service-content">
			<el-form ref="applyForm" :model="applyForm" label-width="140px" size="small">
				<!-- 个人认证基本信息 -->
				<div class="person-service">
					<el-row>
						<el-col :span="24">
							<el-form-item label="待办理事项：">
								<span>{{ bussinessName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="业务角色：">
								<span>{{ roles }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="业务来源：">
								<span>{{ resource }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="主体类型：">
								<span>{{ applyForm.objectType }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="主体名称：">
								<span>{{ applyForm.objectName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="证件类型：">
								<span>{{ applyForm.objectType == '个人' ? applyForm.cardType : '营业执照' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item :label="applyForm.objectType == '个人' ? '证件号：' : '社会信用代码：'">
								<span v-if="applyForm.objectType == '个人'">{{ applyForm.idCard }}</span>
								<span v-else>{{ applyForm.creditCode }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="申请人：">
								<span>{{ applyForm.applyUser }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="申请人账号：">
								<span>{{ applyForm.userName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="申请时间：">
								<span>{{ applyForm.createDate }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="10" >
							<el-form-item label="业务开通协议：" >
								<span class="agree" v-if="typeId != '1002049021'">《{{ agreement }}》</span>
								<div v-if="typeId == '1002049021' && deals.length != 0">
									<span class="agree" v-for="(item,index) in deals" :key="index" @click="openDetail(item)">{{ item.sname }}</span>
								</div>
								<span v-if="typeId == '1002049021' && deals.length == 0">-</span>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>
			<el-row>
				<el-col :span="24" class="mt20">
					<p>审核记录：</p>
					<vxe-table
						align="center"
						auto-resize
						border
						class="mt20"
						:data="checkData"
						highlight-current-row
						highlight-hover-row
						show-overflow="tooltip"
						show-header-overflow="tooltip"
					>
						<vxe-table-column field="status" title="审核结果">
							<template #default="{ row }">
								<span v-if="row.status == 1">通过</span>
								<span v-else-if="row.status == 2">驳回</span>
							</template>
						</vxe-table-column>
						<vxe-table-column field="upUserSname" title="审核人"></vxe-table-column>
						<vxe-table-column field="updateDate" title="审核时间"></vxe-table-column>
						<vxe-table-column field="remark" title="审核意见">
							<template v-slot="{ row }">
								<span>{{ row.remark ? row.remark : '-' }}</span>
							</template>
						</vxe-table-column>
					</vxe-table>
				</el-col>
			</el-row>
		</div>

		<el-dialog
			:title="dialogObj.title"
			v-if="dialogObj.visible"
			:visible.sync="dialogObj.visible"
			width="800px"
			max-height="600px"
			:close-on-click-modal="false"
			@close="handleClose"
			center
		>
			<div class="agree-content" v-html="dialogObj.content"></div>
		</el-dialog>
		
	</div>
</template>
<script>
import * as API from "api/modules/audit";
import { mapState } from "vuex";

export default {
	components: {},
	props: {
		companyId: {
			type: String,
			default: ''
		},
		typeId: {
			type: String,
			default: ''
		},
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			// 企业/个人服务商认证基本资料
			applyForm: {},
			checkData: [], //审核记录
			bussinessName: '', //待办理事项
			roles: '', //业务角色
			resource: '', //业务来源
			agreement: '', //业务开通协议
			deals:[], //专家方业务开通申请协议
			dialogObj:{
				title:'',
				visible:false,
				content:''
			}
		}
	},
	created() {
		this.companyId != '' ? this.getCompanyMsg() : this.goBack()
		this.$nextTick(() => {
			this.dealType()
		})
	},
	methods: {
		// 查询企业/个人服务商认证资料
		getCompanyMsg() {
			API.getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.applyForm = this.$utils.clone(res.data, true)
				// 审核记录 -- 2025-09-19 替换以前的单独接口
				this.checkData = res.data.applyRecords || []
				this.deals = res.data.deals || []
			})
		},

		// 判断是何种类型
		dealType() {
			switch (this.typeId) {
				case '1002049014':
					this.bussinessName = '服务商业务开通申请'
					this.roles = '服务商'
					this.resource = '询匠通'
					this.agreement = '询匠通用户协议'
					break
				case '1002049013':
					this.bussinessName = '招募业务开通申请'
					this.roles = '招募方'
					this.resource = '询匠通'
					this.agreement = '询匠通用户协议'
					break
				case '1002049010':
					this.bussinessName = '雇主方业务开通申请'
					this.roles = '雇主方'
					this.resource = '聚易厅'
					this.agreement = '聚易厅业务开通协议'
					break
				case '1002049016':
					this.bussinessName = '出租业务开通申请'
					this.roles = '出租方'
					this.resource = '租赁通'
					this.agreement = '租赁通用户协议'
					break
				case '1002049017':
					this.bussinessName = '求租业务开通申请'
					this.roles = '求租方'
					this.resource = '租赁通'
					this.agreement = '租赁通用户协议'
					break
				case '1002049019':
					this.bussinessName = '招募方业务开通申请'
					this.roles = '劳务通招募方'
					this.resource = '劳务通'
					this.agreement = '劳务通用户协议'
					break
				case '1002049020':
					this.bussinessName = '服务方业务开通申请'
					this.roles = '劳务通服务方'
					this.resource = '劳务通'
					this.agreement = '劳务通用户协议'
					break
				case '1002049021':
					this.bussinessName = '专家方业务开通申请'
					this.roles = '专家方'
					this.resource = '专家通'
					this.agreement = '专家通用户协议'
					break
			}
		},

		read() {},
		// 审查页返回审计代办页
		goBack() {
			this.$router.push({ path: '/audit-affairs-new' })
		},
		openDetail(item){
			this.dialogObj.content = ''
			API.getZjDeal({id:item.id,userId:this.applyForm.userId}).then((res)=>{
				console.log(res)
				this.dialogObj.visible = true
				this.dialogObj.title = item.sname
				this.dialogObj.content = res.data
			})
		},
		handleClose(){
			this.dialogObj.visible = false
			this.dialogObj.title = ''
			this.dialogObj.content =''
		}
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		mode() {
			return this.$route.query.mode
		}
	}
}
</script>
<style lang="less" scoped>
.service-provider-layout {
	height: 100%;
	overflow-y: auto;
	.service-content {
		padding: 30px 20px;
		position: relative;
		.authentication {
			width: 190px;
			height: 45px;
			line-height: 45px;
			font-size: 16px;
			background-color: #008000;
			text-align: center;
			color: #fff;
			position: absolute;
			left: 0px;
			top: 0px;
		}
		.mt40 {
			margin-top: 40px;
		}
		.top-item-text2 {
			font-size: 12px;
			line-height: 30px;
			color: #666;
			text-align: center;
		}
	}
	.footer {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
	.agree {
		color: #5a79d9;
		cursor: pointer;
		text-decoration: underline;
		font-size: 14px;
		padding-left: 5px;
	}
	.agree-content{
		color: #000;
	}
}
</style>
</style>
